
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'What sedation options do you offer for anxious patients?',
      answer: 'We offer several sedation options including oral sedation (tablets taken before your appointment), inhalation sedation (laughing gas), and IV sedation for more complex procedures. During your free consultation, we\'ll discuss which option is best suited to your needs and anxiety level.'
    },
    {
      question: 'How much does the initial consultation cost?',
      answer: 'Your first consultation is completely free! This gives you the opportunity to meet Dr Saeed and the team, discuss your concerns, and learn about your treatment options without any financial commitment. We believe this helps anxious patients feel more comfortable before making any decisions.'
    },
    {
      question: 'What if I need to take breaks during treatment?',
      answer: 'Absolutely! We encourage you to communicate your needs throughout your appointment. We can establish a simple hand signal that lets us know when you need a break. Your comfort is our priority, and we\'ll work at a pace that feels right for you.'
    },
    {
      question: 'Do you offer payment plans for treatment?',
      answer: 'Yes, we offer 0% interest-free finance options to make your treatment more affordable. We can spread the cost of your treatment over several months, making it easier to get the care you need without financial stress. We\'ll discuss all payment options during your consultation.'
    },
    {
      question: 'How long does a typical appointment take?',
      answer: 'Appointment length varies depending on the treatment needed. For anxious patients, we often schedule longer appointments to ensure we have plenty of time and never feel rushed. Your initial consultation typically takes 30-45 minutes, allowing us to thoroughly discuss your concerns and treatment options.'
    },
    {
      question: 'What makes your practice different for anxious patients?',
      answer: 'Our entire approach is designed around anxious patient care. Dr Saeed has specialised training in sedation dentistry and anxiety management. Our practice environment is calming, our team is specially trained, and we use the latest pain-free techniques. We also offer flexible scheduling, clear communication, and a judgement-free environment where your feelings are always validated.'
    },
    {
      question: 'Can I bring someone with me to my appointment?',
      answer: 'Of course! We welcome you to bring a family member or friend for support. They can stay with you in the waiting room or, in many cases, accompany you into the treatment room if that helps you feel more comfortable.'
    },
    {
      question: 'What if I haven\'t been to a dentist in years?',
      answer: 'You\'re not alone – many of our patients haven\'t visited a dentist in years due to anxiety. We never judge, and we understand that dental anxiety is real. We\'ll start slowly, at your pace, and focus on building your confidence. Your free consultation is the perfect first step to getting back on track with your dental health.'
    }
  ];

  return (
    <section id="faq" className="py-24 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-block bg-[#d0a24f]/10 rounded-full px-6 py-2 mb-4">
            <span className="text-[#d0a24f] text-sm font-semibold whitespace-nowrap">FAQ</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#444c42] mb-6">
            Common Questions About<br />Anxious Patient Care
          </h2>
          <p className="text-lg text-[#7A8178]">
            We've answered some of the most common questions we receive from nervous and anxious patients.
          </p>
        </div>
        
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-[#fafaf8] rounded-2xl overflow-hidden hover:shadow-lg transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-6 text-left cursor-pointer"
              >
                <h3 className="text-lg font-bold text-[#444c42] pr-4">
                  {faq.question}
                </h3>
                <div className={`w-8 h-8 flex items-center justify-center bg-[#d0a24f]/10 rounded-full flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-xl text-[#d0a24f]"></i>
                </div>
              </button>
              
              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}>
                <div className="px-6 pb-6">
                  <p className="text-[#7A8178] leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <p className="text-[#7A8178] mb-6">Still have questions? We're here to help!</p>
          <button onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })} className="bg-[#d0a24f] text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-[#dcb964] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
            Contact Us Today
          </button>
        </div>
      </div>
    </section>
  );
}
